// extracted by mini-css-extract-plugin
module.exports = {"container":"_1C2nLBOyjuU3FS61Rqn8dv","banner":"_1OopijFPiTZTjoD5cR9pbA"};